export default __webpack_public_path__ + "static/media/lamppost.c8bc93a7.png";